var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFaceCamIconMod = function SvgFaceCamIconMod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.152,
    height: 20.385
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceCamIconMod_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Videos Activated"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 163",
    transform: "translate(1.546 3.165)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Video"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-videocam",
    d: "M19.978 14.5v-4.278A1.172 1.172 0 0018.872 9H5.606A1.172 1.172 0 004.5 10.222v12.221a1.172 1.172 0 001.106 1.222h13.266a1.172 1.172 0 001.106-1.222v-4.277l4.422 4.888V9.611z",
    transform: "translate(-2.293 -8.441)",
    fill: "url(#faceCamIconMod_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Video"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-videocam",
    d: "M17.194 5.809V1.291A1.264 1.264 0 0015.966 0H1.228A1.264 1.264 0 000 1.291V14.2a1.264 1.264 0 001.228 1.29h14.738a1.264 1.264 0 001.228-1.29V9.681l4.913 5.163V.645z",
    fill: "none",
    stroke: "#272727"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 93",
    width: 4.813,
    height: 1.203,
    rx: 0.602,
    transform: "translate(10.219 2.666)",
    fill: "#fff"
  })))));
};
export default SvgFaceCamIconMod;